import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgTarget = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M13.009 4.363a.9.9 0 0 1 .251-.787l1.445-1.445a.453.453 0 0 1 .739.153l.649 1.622 1.622.649a.452.452 0 0 1 .153.74l-1.445 1.444c-.206.206-.5.299-.787.25l-1.43-.236-3.503 3.501a.677.677 0 0 1-.957-.956l3.503-3.502-.237-1.43zm2.912 3.99a2.26 2.26 0 0 0 1.273-.489A7.223 7.223 0 0 1 10.227 17 7.227 7.227 0 0 1 3 9.774a7.223 7.223 0 0 1 9.137-6.966 2.24 2.24 0 0 0-.488 1.273 5.868 5.868 0 1 0-1.422 11.562 5.868 5.868 0 0 0 5.694-7.29m-5.697-2.641q.547.002 1.052.138l-1.222 1.222a2.71 2.71 0 1 0 2.873 2.872l1.222-1.222q.136.505.138 1.052a4.064 4.064 0 0 1-8.127 0 4.064 4.064 0 0 1 4.064-4.062"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTarget);
export default ForwardRef;
